import { useQuery } from "@tanstack/react-query";
import { useClient } from "../../hooks/useClient";
import { useDefinition } from "../../hooks/useDefinition";

export function useDesigns() {
	const client = useClient();
	const definition = useDefinition();

	const loadDesignsAsync = () => {
		if (!definition) {
			return Promise.resolve<readonly eXpress.IAlternativeDesign[]>([]);
		}

		const {
			product: { code, aspectRatio, showDesigns },
			theme,
			isAiProduct,
			isAiDesign,
		} = definition;

		return client
			.loadAlternativeDesignsAsync(code, aspectRatio, theme, isAiProduct, isAiDesign)
			.then((d) => {
				if ((!d || !d.length) && showDesigns) {
					// log ProductWarning to server
					client.logErrorAsync(
						new eXpress.ProductWarning(
							"ShowDesignsTab is set to True but no designs were found",
							`No designs found for product ${definition.product.code}`,
						),
						false,
					);
					return [];
				}
				return d;
			});
	};

	return useQuery<readonly eXpress.IAlternativeDesign[]>({
		queryKey: ["use-designs", definition?.product.code, definition?.product.aspectRatio],
		queryFn: loadDesignsAsync,
		meta: {
			logToServer: true,
			errorPrefix: "Error loading designs",
		},
	});
}
